import get from 'lodash/get';
import find from 'lodash/find';
import getComponent from './getComponent';

/**
 * Looks up in site core context if the pre-filled option is set on a component.
 * @param {Object} sitecoreContext
 * @param {string} component - component to be evaluated
 * @returns {string} solution's value
 */

export const getPrefilledSolutionValue = (
  sitecoreContext,
  component = 'EnquiryModal',
) => {
  const prefilledSolutionObj = getPrefilledSolution(sitecoreContext, component);

  return get(prefilledSolutionObj, 'fields.Label.value', '');
};

/**
 * Looks up in site core context if the pre-filled option is set on a component.
 * @param {Object} sitecoreContext
 * @param {string} component - component to be evaluated
 * @returns {Object} solution found
 */
export const getPrefilledSolution = (
  sitecoreContext,
  component = 'EnquiryModal',
) => {
  const enquiryComponent = getComponent(sitecoreContext, component);

  const prefilledSolutionId = get(
    enquiryComponent,
    'fields.PrefilledSolutionId.value',
    '',
  );

  const SolutionsDropdownOptions = get(
    enquiryComponent,
    'fields.SolutionsDropdownOptions',
    [],
  );

  return find(
    SolutionsDropdownOptions,
    solution => solution.id === prefilledSolutionId,
  );
};
